import { useEffect, useState } from 'react';
import english from './interpreterCopy/en.json';

const COPY_LOADERS = {
  es: () => import('./interpreterCopy/es.json'),
  hi: () => import('./interpreterCopy/hi.json'),
  zh: () => import('./interpreterCopy/zh.json'),
  ar: () => import('./interpreterCopy/ar.json'),
  fr: () => import('./interpreterCopy/fr.json'),
  pt: () => import('./interpreterCopy/pt.json'),
  de: () => import('./interpreterCopy/de.json'),
  ja: () => import('./interpreterCopy/ja.json'),
  ko: () => import('./interpreterCopy/ko.json'),
  it: () => import('./interpreterCopy/it.json'),
  tr: () => import('./interpreterCopy/tr.json'),
  id: () => import('./interpreterCopy/id.json'),
  pl: () => import('./interpreterCopy/pl.json'),
  vi: () => import('./interpreterCopy/vi.json'),
  th: () => import('./interpreterCopy/th.json'),
  nl: () => import('./interpreterCopy/nl.json'),
  ru: () => import('./interpreterCopy/ru.json'),
  fil: () => import('./interpreterCopy/fil.json'),
  uk: () => import('./interpreterCopy/uk.json'),
  ro: () => import('./interpreterCopy/ro.json'),
  sv: () => import('./interpreterCopy/sv.json'),
  cs: () => import('./interpreterCopy/cs.json'),
  el: () => import('./interpreterCopy/el.json'),
  hu: () => import('./interpreterCopy/hu.json'),
};

export function useInterpreterCopy(lang) {
  const [copy, setCopy] = useState(english);

  useEffect(() => {
    if (!lang || lang === 'en') {
      setCopy(english);
      return undefined;
    }
    const load = COPY_LOADERS[lang];
    if (!load) {
      setCopy(english);
      return undefined;
    }
    let live = true;
    load()
      .then((mod) => {
        if (live) setCopy(mod.default || mod);
      })
      .catch(() => {
        if (live) setCopy(english);
      });
    return () => {
      live = false;
    };
  }, [lang]);

  return copy;
}

export { english as interpreterEnglish };
